import React, { useEffect, useState } from 'react';
import { Typography, Form, Input, Divider, Select, Space, Row } from 'antd';
import GenericModal from '../../buttons/genericModal';
import { backendGetRequest, backendPatchWithoutRefresh, backendPostWithoutRefresh } from '../../../helpers/callBackend';
import LoadingButton from '@mui/lab/LoadingButton';

function EditOrAddSFTPModal({ record, onSuccess, add }) {
  const [visible, setVisible] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [currentDayFiles, setCurrentDayFiles] = useState([]);
  const [priorDayFiles, setPriorDayFiles] = useState([]);
  const [currentDayFilesLoading, setCurrentDayFilesLoading] = useState(true);
  const [priorDayFilesLoading, setPriorDayFilesLoading] = useState(true);
  const { Text } = Typography;

  const onFormSubmitCloseModal = (values) => {
    setSubmitLoading(true);
    const data = {
      values: {
        ...values,
        // Explicitly set to undefined to avoid potential issues
        bank_name: undefined,
        bank_address: undefined,
        routing_number: undefined,
      },
      source: record.source,
      id: record.id.split('_').pop(),
    }
    if (add) {
      data.values['id'] = record.connections[0].id.split('_').pop();
      backendPostWithoutRefresh("/api/sftp/bank-account-connection/", data.values)
        .then((res) => {
          onSuccess(res.data?.data);
          setSubmitLoading(false);
          setVisible(false);
        });
    } else {
      backendPatchWithoutRefresh("/api/sftp/bank-account-connection/", data)
        .then((res) => {
          onSuccess(res.data?.data);
          setSubmitLoading(false);
          setVisible(false);
        });
    }
  };

  useEffect(() => {
    if (!add) {
      const sftp_connection_id = add ? record.connections[0].id.split('_').pop() : record.id.split('_').pop();
      backendGetRequest("/api/sftp/file/", { params: { sftp_connection_id: sftp_connection_id, cdr: true } })
        .then((res) => {
          setCurrentDayFiles(res?.data?.data);
          setCurrentDayFilesLoading(false);
        });
      backendGetRequest("/api/sftp/file/", { params: { sftp_connection_id: sftp_connection_id, pdr: true } })
        .then((res) => {
          setPriorDayFiles(res?.data?.data);
          setPriorDayFilesLoading(false);
        })
    }
  }, []);

  return (
    <GenericModal
      size="md"
      visible={visible}
      handleCancelModal={() => setVisible(false)}
      showModal={() => setVisible(true)}
      button={add ? "Add New SFTP Connection" : "Edit"}
      modalTitle={add ? `Add SFTP connection for ${record.institution_name}` : `Edit SFTP connection for ${record.description}`}
      modalBody={
        <Space direction="vertical" style={{ width: "100%" }}>
          <Text strong>
            Please record the information of the new account you expect in this connection.
          </Text>
          <Form
            layout="inline"
            name="basic"
            onFinish={onFormSubmitCloseModal}
            autoComplete="off"
            colon={false}
          >
            {!add &&
              <>
                <Text style={{ marginLeft: 10 }}> Bank Information </Text>
                <Divider style={{ margin: 10 }} />

                <Form.Item
                  label={<label style={{ marginRight: 120 }}> Bank Name: </label>}
                  name="bank_name"
                  initialValue={add ? record.connections[0].institution_name : record.institution_name}
                  style={{ marginBottom: 10, marginLeft: 10 }}
                >
                  <Input style={{ width: 300 }} disabled />
                </Form.Item>

                <Form.Item
                  label={<label style={{ marginRight: 105 }}> Bank Address: </label>}
                  name="bank_address"
                  initialValue={add ? record.connections[0].institution_address : record.institution_address}
                  style={{ marginBottom: 10, marginLeft: 10 }}
                >
                  <Input style={{ width: 300 }} disabled />
                </Form.Item>

                <Form.Item
                  label={<label style={{ marginRight: 89 }}> Routing Number: </label>}
                  name="routing_number"
                  initialValue={add ? record.connections[0].routing_number : record.routing_number}
                  style={{ marginBottom: 20, marginLeft: 10 }}
                >
                  <Input style={{ width: 300 }} disabled />
                </Form.Item>
              </>
            }

            <Form.Item
              label={<label style={{ marginRight: 100 }}> Account Name: </label>}
              name="account_name"
              rules={[{ required: true, message: 'Please input your account name!' }]}
              initialValue={add ? undefined : record.account_name}
              style={{ marginBottom: 10 }}
            >
              <Input style={{ width: 300 }} />
            </Form.Item>

            <Form.Item
              label={<label style={{ marginRight: 64 }}> Account Description: </label>}
              name="account_description"
              rules={[{ required: true, message: 'Please input your account description!' }]}
              initialValue={add ? undefined : record.description}
              style={{ marginBottom: 10 }}
            >
              <Input style={{ width: 300 }} />
            </Form.Item>

            <Form.Item
              label={<label style={{ marginRight: 106 }}> Account Type: </label>}
              name="account_type"
              rules={[{ required: true, message: 'Please input your account type!' }]}
              initialValue={add ? undefined : record.account_type}
              style={{ marginBottom: 10 }}
            >
              <Input style={{ width: 300 }} />
            </Form.Item>

            <Form.Item
              label={<label style={{ marginRight: 86 }}> Account Number: </label>}
              name="account_number"
              rules={[{ required: true, message: 'Please input your account number!' }]}
              initialValue={add ? undefined : record.account_number}
              style={{ marginBottom: 10 }}
            >
              <Input style={{ width: 300 }} />
            </Form.Item>

            <Form.Item
              label={<label style={{ marginRight: 81 }}> Beneficiary Name: </label>}
              name="beneficiary_name"
              initialValue={add ? undefined : record.beneficiary_name}
              style={{ marginBottom: 10, marginLeft: 10 }}
            >
              <Input style={{ width: 300 }} />
            </Form.Item>

            <Form.Item
              label={<label style={{ marginRight: 66 }}> Beneficiary Address: </label>}
              name="beneficiary_address"
              initialValue={add ? undefined : record.beneficiary_address}
              style={{ marginBottom: 20, marginLeft: 10 }}
            >
              <Input style={{ width: 300 }} />
            </Form.Item>

            {!add &&
              <>

                <Text style={{ marginLeft: 10 }}> File Transfer Set Up </Text>
                <Divider style={{ margin: 10 }} />
                <Form.Item
                  label={<label style={{ marginRight: 110 }}> Prior Day File: </label>}
                  name="file"
                  rules={[{ required: true, message: 'Please select your prior day file!' }]}
                  style={{ marginBottom: 10 }}
                >
                  <Select
                    loading={priorDayFilesLoading}
                    dropdownMatchSelectWidth={false}
                    disabled={priorDayFilesLoading}
                    style={{ width: 300 }}
                  >
                    {priorDayFiles.map(file => (
                      <Select.Option key={file.id} value={file.id}>
                        {file.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  label={<label style={{ marginRight: 91 }}> Current Day File: </label>}
                  name="current_day_file"
                  style={{ marginBottom: 10, marginLeft: 10 }}
                >
                  <Select
                    loading={currentDayFilesLoading}
                    disabled={currentDayFilesLoading}
                    dropdownMatchSelectWidth={false}
                    style={{ width: 300 }}
                  >
                    {currentDayFiles.map(file => (
                      <Select.Option key={file.id} value={file.id}>
                        {file.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </>
            }

            <Text type="secondary" italic>
              Note: If this account is not identified in the SFTP file, the balances and transactions will not refresh.
              Please confirm with your Arpari account manager if you do not see this account update. If you
              know this account is not in the file transfer file, you will need to notify the treasury manager at your bank to have this added.
            </Text>
            <Form.Item>
              <LoadingButton
                htmlType="submit"
                loading={submitLoading}
                loadingPosition='start'
                sx={{ fontSize: 14, textTransform: 'none', marginTop: 1, width: '100px' }}
                disableElevation fullWidth size="small" type="submit" variant="contained" color="primary"
              >
                Submit
              </LoadingButton>
            </Form.Item>
          </Form>
        </Space>
      }
    />
  );
}

export default EditOrAddSFTPModal;
